/** Pass a `*Values` array from openapi-typescript's `--enum-values` so new spec values appear after a regen. */

// "ExtractionFailed" -> "Extraction Failed". Acronyms (e.g. the obsolete OCR states) need a `label` override.
function humanize(value: string): string {
  return value
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
}

export interface EnumOption<T extends string> {
  value: T | "All";
  label: string;
}

export function enumOptions<T extends string>(
  values: readonly T[],
  opts?: { all?: boolean; label?: (value: T) => string },
): EnumOption<T>[] {
  const items: EnumOption<T>[] = values.map((value) => ({
    value,
    label: opts?.label?.(value) ?? humanize(value),
  }));
  return opts?.all ? [{ value: "All", label: "All" }, ...items] : items;
}
